class Controller {
  constructor(Events, $stateParams, Sections) {
    "ngInject";

    this.activeParams = $stateParams;

    this.filterEvent = Events.getFilterEvent("invoices");
    this.sortEvent = Events.getSortEvent("invoices");
    this.paginateEvent = Events.getPaginateEvent("invoices");

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.sections = Sections.plansSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices.controller.js